module.exports = __webpack_public_path__ + "img/edit3.c905f5fd.svg";